import Link from "next/link"

export function CategoriesBox({ categories }) {
  return (
    <nav className="flex flex-col lg:sticky top-12 gap-y-4 lg:self-start text-navy lg:border-l lg:border-l-blue lg:pb-6 lg:pl-4">
      <h2 className="font-secondary font-bold text-m1 hover:underline leading-none uppercase w-max pb-2">
        <Link href="/blog/page/1">Categories</Link>
      </h2>
      {categories?.map((category, idx) => (
        <Link
          href={`/blog/category/${category?.value.toLowerCase()}/1`}
          className="plain-navy-arrow font-primary sm:w-max text-navy uppercase hover:underline relative"
          key={idx}
        >
          {category?.name.toLowerCase()}
        </Link>
      ))}
    </nav>
  )
}
